import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';

import { TextField } from 'components/common/ReactHooksFormFields';
import { deleteWidget } from 'store/appSlice';

import { useTranslation } from 'components/providers/TranslationProvider';
import Modal from 'components/common/Modal';
import {
  MuiButtonClose,
  MuiButtonDelete, MuiIconButtonDelete,
  MuiTypographyContent,
} from 'components/views/organizations/common/styles/modalDelete';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const schema = yup.object().shape({
  name: yup.string().required(),
  nameConfirmation: yup.string().oneOf(['delete','eliminar','supprimer','excluir',null], 'confirm_to_operation'),
});

const DeleteWidget = () => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const query = React.useMemo(() => new URLSearchParams(location.search), [location.search]);

  const widget = location.state;

  const methods = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
  });
  const {
    formState: { errors, isValid },
    setValue,
    reset,
  } = methods;

  React.useEffect(() => {
    const deleteQuery = query.get('delete-widget');
    setOpen(deleteQuery !== null);
    setValue('name', location.state?.name);
  }, [query, location.state, setValue]);

  const handleClose = () => {
    query.delete('delete-widget');
    query.delete('group-id');
    reset({ name: '', nameConfirmation: '' });
    navigate(`${location.pathname}${query && ''}${query}`, { replace: true });
  };

  const handleSubmit = () => {
    dispatch(deleteWidget(widget.id));
    handleClose();
  };

  const actions = (
    <>
      <MuiButtonClose
        onClick={handleClose}
        color='primary'
        variant='text'
        focusRipple
      >
        {t('cancel_btn')}
      </MuiButtonClose>
      <MuiButtonDelete
        onClick={handleSubmit}
        type='submit'
        variant='outlined'
        disabled={!isValid}
      >
        {t('delete')}
      </MuiButtonDelete>
    </>
  );

  const contentModal = (
    <FormProvider {...methods}>
      <Grid container display='flex' direction='column' alignItems='center' justifyContent='center'>
        <MuiIconButtonDelete>
          <DeleteOutlinedIcon fontSize='medium'/>
        </MuiIconButtonDelete>
        <Grid item xs={9}>
          <MuiTypographyContent>
            {t('delete_widget_content')}
          </MuiTypographyContent>
          <p style={{textAlign:'center', marginTop:'-10px'}}>
            <strong>{location.state?.name}</strong>
          </p>
        </Grid>
      </Grid>
      <TextField
        autoFocus
        name='nameConfirmation'
        margin='dense'
        type='text'
        label={t('confirm_to_operation')}
        variant='outlined'
        fullWidth
        error={t(errors.nameConfirmation?.message)}
      />
    </FormProvider>
  );

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        isDelete
        actions={actions}
      >
        {contentModal}
      </Modal>
    </>
  );
};

export default DeleteWidget;
